import React, { useEffect, useState } from 'react';
import NewTimesheetPanel from '../../consultants-vision-admin/timesheet/NewTimesheetPanel';
import Timesheet from '../../consultants-vision-admin/timesheet/Timesheet';
import { Toaster } from '@/components/organisms/feedback/toaster';
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import InViewComponent from '@/components/organisms/InViewComponent';
import { useConsultantTimesheets } from '@/services/admin-services/query/useConsultantTimesheets';
import { useParams } from 'react-router-dom';
import PrintWarningMessage from '@/components/organisms/feedback/PrintWarningMessagee';
import PrintEmptyDataMessage from '@/components/molecules/PrintEmptyDataMessage';
import { Label } from '@/components/atoms/texts/label';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import MultiSelectorComponent, { ContentType } from "@/components/macro-organisms/tabs/MultiSelectorComponent";

export default function TimesheetTab() {
    const [lastSlice, setLastSlice] = useState(1);
    const [timesheetsCopy, setTimesheetsCopy] = useState([]);
    const { loading, error, data: timesheets, refetch } = useConsultantTimesheets(1);
    const { id } = useParams();

    const refetchFromScratch = (n = 1) => {
        // console.log("debug refetchFromScratch")

        setLastSlice(n);
        setTimesheetsCopy([]);
        // pour éviter que refetchFromScratch vide les données
        refetch(n).then((res) => {
            // console.log("debug res = ", res.loading, res.error, res.data);
            if (res.data.consultantTimesheets.timesheets) {
                //màj :les admins veulent voir les timesheets en brouillons
                const timesheetsNotDraft = res.data.consultantTimesheets.timesheets.filter(item => item.status !== "DRAFT");
                setTimesheetsCopy(res.data.consultantTimesheets.timesheets);
            }
        });
    };

    const fetchNewSlice = () => {
        if (!loading && timesheetsCopy.length > 0 && timesheets?.hasNext) {
            setLastSlice((prevSlice) => prevSlice + 1);
        }
    };

    useEffect(() => {
        // console.log("debug timesheets", timesheets,"timesheetsCopy",timesheetsCopy, loading,"lastSlice", lastSlice)
        if (!loading && timesheets) {
            //màj :les admins veulent voir les timesheets en brouillons
            const timesheetsNotDraft = timesheets?.timesheets.filter(item => item.status !== "DRAFT");

            const timesheetsIncludesDraft = timesheets?.timesheets
            // console.log("debug timesheetsNotDraft", timesheetsNotDraft)
            if (lastSlice == 1) {
                setTimesheetsCopy(() => [
                    ...timesheetsIncludesDraft
                ]);
            } else {
                setTimesheetsCopy((prevTimesheets) => [
                    ...prevTimesheets,
                    ...timesheetsIncludesDraft
                ]);
            }

        }
    }, [timesheets]);

    useEffect(() => {
        // console.log("debug timesheetsCopy change", timesheetsCopy)
    }, [timesheetsCopy]);

    useEffect(() => {
        refetchFromScratch();
    }, [id]);

    return (
        <div className="flex flex-col items-end gap-secondDegree overflow-auto pb-secondDegree px-1">
            {/* START WARNING BOOND MANAGER  */}
            {/* import WarningRoundedIcon from '@mui/icons-material/WarningRounded'; */}
            {window.ENV.BOOND_MANAGER_ACTIVE_MODE && <div className="bg-warning w-full p-1 items-center justify-center flex gap-betweenText rounded-sm">
                <WarningRoundedIcon className="mr-1" />
                <Label message="boondManager.timesheet" />
                <a target="blank" href={window.ENV.BOOND_MANAGER_URL + ``}><Label className="underline cursor-pointer" message="boondManager.linkBM"></Label></a>
            </div>}
            {/* END WARNING BOOND MANAGER */}
            <div className="flex gap-secondDegree">
                <Toaster />
            </div>

            {loading && <div className="w-full flex justify-center"><span className="loader" /></div>}
            {error && <PrintErrorMessage error={error} />}
            {(!error && !loading && timesheetsCopy.length > 0) && timesheetsCopy.map((item, index) => (

                <MultiSelectorComponent
                    key={item.uuid}
                    idOfContent={item.uuid}
                    typeOfContent={ContentType.TIMESHEET}
                    idConsultant={id}
                >
                    <Timesheet key={index} data={item} refetchTimesheets={refetchFromScratch} />
                </MultiSelectorComponent>

            ))}
            {/* {console.log("debug", !error && !loading && timesheetsCopy.length > 0, error, loading, timesheetsCopy, timesheetsCopy.length)} */}
            {(!error && !loading && timesheetsCopy.length === 0) && <PrintEmptyDataMessage message="error.emptyDataTimesheet" />}

            <InViewComponent inView={fetchNewSlice} />
        </div>
    );
}
